import { returnFuncIfServer } from "@faire/web--source/common/globals/returnFuncIfServer";
import debounce from "lodash/debounce";
export function debounceIfPossible(func, wait, options) {
    return returnFuncIfServer(func) || debounce(func, wait, options);
}
